/* eslint-disable react/prop-types */
import React, { Fragment, useRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { VariableSizeList } from 'react-window'
import { ThemeProps } from '../../../../shared/prop-types/ReducerProps';
import ReactTableDnDBody from './ReactTableDnDBody';
import useWindowResize from './useWindowResize';

const Row = ({ data, index, setSize, windowWidth, prepareRow, setStyle }) => {
  const rowRef = useRef();

  React.useEffect(() => {
    setSize(index, rowRef.current.getBoundingClientRect().height);
  }, [setSize, index, windowWidth]);
  const row = data[index];
  prepareRow(row)
  return (
    <tr ref={rowRef} className="table-row">
      {row.cells.map(cell => (<>

        <td {...setStyle(cell)}

        >{cell.render('Cell')}</td>
      </>
      ))}
    </tr>
  );

};


const ReactTableDefaultBody = ({ getTableBodyProps, prepareRow, page }) => {
  const setStyle = (cell) => {
    const prop = cell.getCellProps();
    let { style } = prop;

    if (cell?.column?.rightAlign) {
      style = { ...style, textAlign: cell?.column?.rightAlign ? "right" : "left" }
    }

    if (cell?.column?.width) {
      style = { ...style, width: cell.column.width }
    }

    return { ...prop, style }
  }

  const listRef = useRef();
  const sizeMap = useRef({});
  const setSize = useCallback((index, size) => {
    sizeMap.current = { ...sizeMap.current, [index]: size };
    listRef.current.resetAfterIndex(index);
  }, []);
  const getSize = index => sizeMap.current[index] || 50;
  const [windowWidth] = useWindowResize();

  return (
    <tbody className="table table--bordered" {...getTableBodyProps()}>
      <VariableSizeList
        ref={listRef}
        height={400}
        itemCount={page.length}
        itemSize={getSize}
        width="100%"
        itemData={page}
      >
        {({ data, index, style }) => (
          <div style={style}>
            <Row
              style={style}
              data={data}
              index={index}
              setSize={setSize}
              windowWidth={windowWidth}
              prepareRow={prepareRow} setStyle={setStyle}
            />
          </div>
        )}
      </VariableSizeList>

    </tbody>
  );
}

ReactTableDefaultBody.propTypes = {
  page: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  getTableBodyProps: PropTypes.func.isRequired,
  prepareRow: PropTypes.func.isRequired,
  totalColumnsWidth: PropTypes.number.isRequired,
  rows: PropTypes.arrayOf({}).isRequired
};

const ReactTableBody = ({
  page, getTableBodyProps, prepareRow, withDragAndDrop, updateDraggableData, theme, rows, totalColumnsWidth
}) => (
  <Fragment>
    {withDragAndDrop
      ? (
        <ReactTableDnDBody
          page={page}
          getTableBodyProps={getTableBodyProps}
          prepareRow={prepareRow}
          updateDraggableData={updateDraggableData}
          theme={theme}
        />
      ) : (
        <ReactTableDefaultBody
          page={page}
          getTableBodyProps={getTableBodyProps}
          prepareRow={prepareRow}
          rows={rows}
          totalColumnsWidth={totalColumnsWidth}
        />
      )}
  </Fragment>
);

ReactTableBody.propTypes = {
  page: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  getTableBodyProps: PropTypes.func.isRequired,
  prepareRow: PropTypes.func.isRequired,
  updateDraggableData: PropTypes.func.isRequired,
  withDragAndDrop: PropTypes.bool.isRequired,
  theme: ThemeProps.isRequired,
  totalColumnsWidth: PropTypes.number.isRequired,
  rows: PropTypes.arrayOf({}).isRequired
};

export default connect(state => ({
  theme: state.theme,
}))(ReactTableBody);
